import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const TEST_SMTP_CONFIGURATION_MUTATION = gql`
  mutation TestSmtpConfiguration($recipientEmail: String!) {
    testSmtpConfiguration(recipientEmail: $recipientEmail) {
      sent
    }
  }
`;

interface TestSmtpConfigurationResponse {
  testSmtpConfiguration: {
    sent: boolean;
  };
}

interface UseTestSmtpConfigurationOptions {
  onCompleted?: () => void;
  onError?: (error: any) => void;
}

export function useTestSmtpConfiguration(options?: UseTestSmtpConfigurationOptions) {
  const [testSmtpConfigurationMutation, { loading }] = useMutation<TestSmtpConfigurationResponse>(TEST_SMTP_CONFIGURATION_MUTATION, {
    onCompleted: () => {
      toast.success('E-mail de teste enviado com sucesso.');
      options?.onCompleted?.();
    },
    onError: (error: any) => {
      if (options?.onError) {
        options.onError(error);
      } else {
        const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao testar configuração SMTP';
        toast.error(message);
      }
    },
  });

  const testSmtpConfiguration = (recipientEmail: string) => {
    return testSmtpConfigurationMutation({
      variables: { recipientEmail },
    });
  };

  return { testSmtpConfiguration, loading };
}
